"use strict";
var ng_redux_1 = require('./components/ng-redux');
exports.NgRedux = ng_redux_1.NgRedux;
var select_1 = require('./decorators/select');
exports.select = select_1.select;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-redux/lib/index.js
 ** module id = 125
 ** module chunks = 0
 **/